<template>
  <div class="c-general-tab__section">
    <h3>File Name</h3>
    <div>
      {{ source?.table }}
    </div>
  </div>
  <div class="c-general-tab__section">
    <h3>Uploaded on</h3>
    <div v-if="source?.created_at">
      {{ date }}
    </div>
  </div>
  <FieldMappingSection />
  <div class="c-general-tab__section" v-if="allowAddData">
    <div class="c-general-tab__section-with-description">
      <div>
        <h3 class="mb-4">Add Data</h3>
        <div class="c-general-tab__section-with-description__text">
          <span>
            Adding data to an existing CSV data source merges the data into 1
            unique dataset
          </span>
        </div>
      </div>
      <BittsButton
        :disabled="sourceDisabled"
        :left-icon="['fak', 'add']"
        text="Add Data"
        variant="outline"
        size="small"
        data-testid="add-data-btn"
        @click="showAddDataModal"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { BittsButton } from '@crossbeam/bitts';

import { DateTime } from 'luxon';
import { computed } from 'vue';
import { useRouter } from 'vue-router';

import useDataSourceSettings from '@/composables/useDataSourceSettings';
import { todayYesterdayTomorrowOrCustom } from '@/date_time_utils';

import FieldMappingSection from './FieldMappingSection.vue';

const router = useRouter();

const { allowAddData, source, sourceDisabled, uploadedByEmail } =
  useDataSourceSettings();

const date = computed(() => {
  const formatter = (d: DateTime) => d.toFormat("D 'at' t");
  const formattedDate = todayYesterdayTomorrowOrCustom(
    DateTime.fromISO(source.value?.created_at || ''),
    true,
    formatter,
  );
  if (uploadedByEmail.value) {
    return `${formattedDate} by ${uploadedByEmail.value}`;
  }
  return formattedDate;
});

function showAddDataModal() {
  router.push({ name: 'csv-add-data' });
}
</script>
